<template>
  <UApp>
    <ClientOnly>
      <div>
        <NuxtLayout>
          <DataPlaceholder
            :description="$t('web_error_page_not_found')"
            :type="PlaceholderPageType.NOT_FOUND"
          />
        </NuxtLayout>
      </div>
    </ClientOnly>
    <MiscTeleports />
  </UApp>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';
import { PlaceholderPageType } from '~/types/placeholderPageType';
import DataPlaceholder from '~/components/misc/DataPlaceholder.vue';

const { error } = defineProps<{
  error: NuxtError;
}>();

onMounted(() => {
  if (window.plgFaro) {
    window.plgFaro.api.pushError(error);
  }
});

onBeforeUnmount(() => {
  clearError();
});
</script>
